/**
 * Pufien — DIY otomatik hediye çorap (app YOK).
 *
 * Kural (eşik bazlı):
 *   • Sepet ara toplamı ≥ 100 TL → hediye çorap (0₺) otomatik EKLENİR.
 *   • < 100 TL → hediye çorap otomatik ÇIKARILIR.
 *   • Adet 1'e sabit. (UI'da stepper gizli; silme butonu güvenlik için açık.)
 *
 * KRİTİK: mevcut hediye satırını değiştirirken/silerken VARYANT ID değil,
 * cart.js'ten gelen SATIR ANAHTARI (item.key) kullanılır — /cart/change.js
 * varyant id'yi (sayı) bazen satır-index sanıp işi sessizce boşa çıkarıyordu
 * (add çalışıp remove çalışmamasının sebebi buydu).
 *
 * Sağlamlık: cart:update olayı + tüm /cart/{add,change,update,clear} fetch
 * interception + /cart.js cache:'no-store'. Kendi mutasyonları döngüye sokulmaz.
 * Hepsi try/catch → sepeti bozmaz.
 */
import { CartUpdateEvent, ThemeEvents } from '@theme/events';

const GIFT_ID = Number(window.PF_GIFT_VARIANT_ID || 0);
const MIN_SUBTOTAL = 10000; // 100 TL (kuruş)
const SOURCE = 'pf-free-gift';

if (GIFT_ID > 0) {
  let busy = false;
  let selfMutating = false;

  const sectionIds = () => {
    const ids = new Set();
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (el.dataset && el.dataset.sectionId) ids.add(el.dataset.sectionId);
    });
    return Array.from(ids);
  };

  const getCart = async () =>
    (await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })).json();

  const post = async (url, body) => {
    selfMutating = true;
    try {
      return await (await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        cache: 'no-store',
        body: JSON.stringify(body),
      })).json();
    } finally {
      selfMutating = false;
    }
  };

  const isGift = (i) => i && (i.id === GIFT_ID || i.variant_id === GIFT_ID);

  const reconcile = async () => {
    if (busy) return;
    busy = true;
    try {
      const cart = await getCart();
      const items = Array.isArray(cart.items) ? cart.items : [];
      const gift = items.find(isGift);
      const subtotal = items.reduce(
        (s, i) => s + (isGift(i) ? 0 : (i.final_line_price != null ? i.final_line_price : (i.line_price || 0))),
        0
      );
      const secParam = sectionIds().join(',');
      let resp = null;

      if (subtotal >= MIN_SUBTOTAL) {
        if (!gift) {
          resp = await post('/cart/add.js', {
            items: [{ id: GIFT_ID, quantity: 1 }], sections: secParam, sections_url: location.pathname,
          });
        } else if (gift.quantity !== 1) {
          resp = await post('/cart/change.js', {
            id: gift.key, quantity: 1, sections: secParam, sections_url: location.pathname,
          });
        }
      } else if (gift) {
        // < 100 TL → hediyeyi çıkar. SATIR ANAHTARI ile (kesin tanımlayıcı).
        resp = await post('/cart/change.js', {
          id: gift.key, quantity: 0, sections: secParam, sections_url: location.pathname,
        });
      }

      if (resp) {
        const fresh = await getCart();
        document.dispatchEvent(
          new CartUpdateEvent(fresh, SOURCE, { source: SOURCE, sections: resp.sections })
        );
      }
    } catch (e) {
      if (window.console && console.warn) console.warn('[pf-free-gift]', e);
    } finally {
      busy = false;
    }
  };

  const trigger = () => setTimeout(reconcile, 150);

  document.addEventListener(ThemeEvents.cartUpdate, (e) => {
    if (e && e.detail && e.detail.data && e.detail.data.source === SOURCE) return;
    trigger();
  });

  const origFetch = window.fetch;
  window.fetch = function (...args) {
    let url = '';
    try { url = String((args[0] && args[0].url) || args[0] || ''); } catch (e) { /* no-op */ }
    const p = origFetch.apply(window, args);
    if (!selfMutating && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(() => trigger()).catch(() => {});
    }
    return p;
  };

  const start = () => setTimeout(reconcile, 400);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}
